import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SalesProcessRegular from './sales-process-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SalesProcessRegular {...validProps} />;
}
SvgComponent.iconName = 'salesProcessRegular';

export const SalesProcessRegularIcon = svgIconWrapper(SvgComponent);
